<template>
  <div class="learingAbout">
    <backHeader back-addr="/person"></backHeader>
    <div style="height:10px;"></div>
    <div id="about" style="text-align:left;margin-left:9px;margin-right:9px;">
                <img src="../assets/about.png" alt="" id="about-img">
                <!-- <img :src="logoImg" alt="" id="about-img"> -->
                <br />
                <br />
                <br />
                <br />
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;《学习标兵》是以习近平新时代中国特色社会主义思想、百年建党经验、“四史”教育等为主题的综合学习软件，探索以虚拟仿真、地理空间信息、大数据等技术赋能思政理论学习的新方式，为青年学生、党员干部打造精准、多维、交互、趣味的网络学习空间，以增进对“中国共产党为什么能”、“马克思主义为什么行”、“中国特色社会主义为什么好”的认识和理解，从而坚定道路自信、理论自信、制度自信、文化自信。该软件是由哈尔滨医科大学马克思主义学院与黑龙江地理信息工程院共同研发。
                </p>
                <br/>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;《学习标兵》设计了“寻习足迹”、“图说四史”、“铸魂育人”、“红医传承”为四大版块。“寻习足迹”包含习近平成长足迹、国内足迹、外交足迹、红色足迹、指挥抗疫五个子板块，梳理新时代中国特色社会主义思想；“图说四史”包含中共党史、新中国史、改革开放史、社会主义发展史四个子版块，追溯社会主义思想源头活水；“铸魂育人”包含思政联盟、青马慕课、大中小思政一体化三个子版块，铸造思政教育家园。“红医传承”凸显医学特色和红色基因，发扬革命人道主义和苍生大医精神。
                </p>
                <br/>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;感谢大家使用本软件，欢迎提出反馈意见和改进建议！
                </p>
                <br />
                <br />
                <p style="text-align:center;">
                    联系方式
                </p>
                <br />
                <div>
                    <div style="display:flex;text-align:center;">
                        <div style="flex:1;">
                            哈尔滨医科大学
                        </div>
                        <div style="flex:1;">
                            &nbsp;&nbsp;&nbsp;李中华
                        </div>
                        <div style="flex:1;">
                            13613660077
                        </div>
                    </div>
                    <div style="display:flex;text-align:center;">
                        <div style="flex:1.2;">
                            黑龙江地理信息工程院
                        </div>
                        <div style="flex:0.8;">
                            王林
                        </div>
                        <div style="flex:1;">
                            13384615013
                        </div>
                    </div>
                </div>
                <br />
                <div style="height:40px;"></div>
            </div>
  </div>
</template>
<script>
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import { Toast } from "mint-ui";
import crossLine from "./../components/cross-line.vue";
import backHeader from "./../components/back-header.vue";

export default {
  name: "learingAbout",
  data() {
    return {};
  },
  methods: {
    loadMore() {
      this.loading = true;
      setTimeout(() => {
        // let last = this.list[this.list.length - 1];
        // for (let i = 1; i <= 10; i++) {
        //   this.list.push(last + i);
        // }
        this.loading = false;
      }, 2500);
    }
  },
  mounted: function() {},
  components: {
    crossLine,
    backHeader
  }
};
</script>

<style lang="scss"  scoped>
@import "../assets/baseScss";
p,div {
  font-size: 14px;
  color: #8f8f94;
}
</style>



// WEBPACK FOOTER //
// src/module-person/about.vue